import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import socket from "../../../context/socket";
import KeyActionPointTwo from "./ActionPointsTwo";
import api from "../../../utils/api";

const ActionPoints = () => {
  const [selectedCards, setSelectedCards] = useState(new Set());  
  const [actionPoints, setActionPoints] = useState([]);
  const [actionPointsLoading, setActionPointsLoading] = useState(true);

  const location = useLocation();
  const roomId = new URLSearchParams(location.search).get("clientId");
  const navigate = useNavigate();

  console.log("Selected Cards:", selectedCards,actionPoints);  

  // Fetching Action Points from DB
  useEffect(() => {
    setActionPointsLoading(true);
  api
    .get(`advisor/get_key_action_points/${roomId}`)
    .then((response) => {
      // ✅ Sort by numeric `id`
      const sortedPoints = response.data.sort((a, b) => a.id - b.id);

      setActionPoints(sortedPoints);
      setActionPointsLoading(false);

      // ✅ Set selected cards initially
      const initiallySelected = new Set(
        sortedPoints
          .filter((point) => point.is_checked === 'yes')
          .map((point) => point.id)
      );

      setSelectedCards(initiallySelected);
    })
    .catch((error) => console.error("Error fetching data:", error));
}, [roomId]);


  // Handling Checkbox Selection
  const handleCheckboxChange = (cardId) => {
    const isChecked = !selectedCards.has(cardId); // Toggle state

    setSelectedCards((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (isChecked) {
        newSelected.add(cardId);
      } else {
        newSelected.delete(cardId);
      }
      return newSelected;
    });

    // ✅ Call your API on checkbox change
    api
      .put(`advisor/update_action_points`, {
        client_id: roomId,
        key_action_id: cardId,
        is_checked: isChecked ? "yes" : "no",
      })
      .then((res) => {
        console.log("✔️ Action updated:", res.data);
      })
      .catch((err) => {
        console.error("❌ Error updating action:", err);
      });
  };

  // Send Selected Cards to Client via Socket
  useEffect(() => {
    if (roomId) {
      socket.emit("message", { room: roomId, data: { selectedCards: Array.from(selectedCards) } });
      console.log("Sent to Socket:", Array.from(selectedCards));
    }
  }, [selectedCards, roomId]);

  const saveActionPoints = () => {
    // Convert selected Set to ordered array
    const selectedIds = Array.from(selectedCards);
  
    // Filter and map selected cards with key_id as index + 1
    const selectedCardData = selectedIds.map((id, index) => {
      const card = actionPoints.find((c) => c.id === id);
      return {
        key_id: card._id || card.id,
        description: card.description,
        status: 1
      };
    });
  


    const allData = {
      _id: roomId,
      keyActionPoints: selectedCardData,
    };
  

    console.log("Updated Cards:", allData);
  
    api
      .post(`advisor/save_action_points`, allData)
      .then(() => {
        
      })
      .catch((error) => console.error("Error saving data:", error));
  };

  // Navigate Next
  const handleNext = () => {
    // Convert selected Set to ordered array
    const selectedIds = Array.from(selectedCards);
  
    // Filter and map selected cards with key_id as index + 1
    const selectedCardData = selectedIds.map((id, index) => {
      const card = actionPoints.find((c) => c.id === id);
      return {
        key_id: card._id || card.id,
        description: card.description,
        status: 1
      };
    });
  


    const allData = {
      _id: roomId,
      keyActionPoints: selectedCardData,
    };
  

    console.log("Updated Cards:", allData);
  
    api
      .post(`advisor/save_action_points`, allData)
      .then(() => {
        const nextUrl = `/investing-belief?clientId=${roomId}`;
        const nextUrl2 = `/investing-belief`;

        socket.emit("navigate", { room: roomId, url: nextUrl2 });
        navigate(nextUrl);
      })
      .catch((error) => console.error("Error saving data:", error));
  };
  
  
  

  // Navigate Back
  const handleBack = () => {
    const prevUrl = `/personal-finance?clientId=${roomId}`;
    const prevUrl2 = `/personal-finance`;

    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  return (
    <>
      <div className="container minht">
        <div className="row">
          <div className="col">
            <h2 className="mb-4">Key Action Points</h2>
          </div>
        </div>
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="scroll-container">
              
              <div className="d-flex align-items-start mb-2">
                <div className="row">
                  <div className="col-auto mt-2">
                    <input type="checkbox" checked readOnly />
                  </div>
                  <div className="col">
                    <label className="m-0 f-size-key-action-point-text">
                      {/* By getting a structured Financial Plan made, you are already in the top 1% of our population in terms of financial strength and readiness. */}
                      By putting your ‘Dreams into Action’, you are already in the top 1% of our population in terms of financial strength and readiness. Please continue basing your future financial decisions around this Investment Plan!
                    </label>
                  </div>
                </div>
              </div>
              {
                actionPointsLoading && (
                  <div className="text-center my-4">
                    <div className="spinner-border text-[#23674b]" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )
              }

              {actionPoints.map((card) => (
                card.description&&
                <div key={card.id} className="d-flex align-items-start mb-2">
                  <div className="row ">
                    <div className="col-auto mt-2">
                      {card.description && card.description.trim() !== '' &&
                        
                          <input
                          // onBlur={saveActionPoints}
                        type="checkbox"
                        checked={selectedCards.has(card.id)}
                        onChange={() => handleCheckboxChange(card.id)}
                        />
                      }
                    </div>
                    <div className="col">
                      <label className="m-0 f-size-key-action-point-text">{card.description && card.description.trim() !== ''&&card.description}</label>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* <div>

          <KeyActionPointTwo actionpoints = {actionPoints}/>
        </div> */}
      </div>

      {/* Navigation Buttons */}
      <div className="container my-4">
        <div className="row">
          <div className="col text-end">
            <a href="#" onClick={handleBack}>
              <img className="arrow_next1" src="assets/images/left-arrowpng.png" alt="Back" />
            </a>
            <a href="#" className="ms-1" onClick={handleNext}>
              <img className="arrow_next" src="assets/images/right-arrow.svg" alt="Next" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActionPoints;
